// Dialogs of older sections get the new look while a page in the new design is open (styles.scss, .pp-v2-modals).
// Counted, as the next page can mount before the last one is destroyed.
let open = 0;

export function v2ModalsOn() {
  open++;
  document.body.classList.add('pp-v2-modals');
}

export function v2ModalsOff() {
  open = Math.max(open - 1, 0);
  if (!open) {
    document.body.classList.remove('pp-v2-modals');
  }
}
